<template>
  <v-container class="play-page hero" fluid style="min-height:100vh;">
    <top-nav-bar :user="user"/>
    <v-btn block tile color="red darken-4" class="mb-2" @click="goTo('/')"><v-icon class="mr-1" size="17">mdi-arrow-left</v-icon> BACK TO DASHBOARD</v-btn>
    <v-row class="pl-2 pr-2">
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="main-play-page pl-4 pr-4" outlined style="background-color:rgb(16,16,16);">
        <bet-history :side-colors="sideColors" :load-more="getHistory" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mixin from "@/mixins";
import rules from "@/mixins/rules";
import helpers from "@/mixins/helpers";
import TopNavBar from "@/sections/TopNavBar";
import BetHistory from "./../sections/BetHistory";

export default {
  mixins: [mixin, rules, helpers],
  components: {
    TopNavBar,
    BetHistory,
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    goTo(path) {
      this.$router.push({ path: path }).catch(() => {
        this.drawer = false;
      });
    },
    
  },

  mounted() {
    this.$nextTick(() => {
      this.bootGame();
      if (this.user.is_si_player && this.user.credits < 1)
        this.$store.dispatch("showWalletModal");
    });
    this.actionSub = this.$store.subscribeAction((action) => {
      if (action.type === "getHistory") this.getHistory(1, 500, true);
      if (action.type === "getRandomHistory") this.getRandomHistory();
      if (action.type === "getTrends") this.getTrends();
    });
  },

};
</script>

<style>
.credits-tab {
  width: 100%;
  margin: 10px;
}
.credits-tab.active {
  background-color: #fff;
}
.gateway-logo img {
  width: 64px;
  margin: 0 auto;
  border-radius: 4px;
}
</style>
